import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { NavSidebar, NotificationStack, NotFound } from "@redriver/cinnamon";
import { AppRoutes, BookingRoutes, SystemRoutes } from "constants/routes";
import { DashboardPage, RepDetailsPage } from "pages/reps";
import TermsAndConditionsPage from "./TermsAndConditionsPage";
import BookingsListPage from "./BookingsPage";
import BookingDetailsPage from "./BookingDetailsPage";
import TemplateDocumentsPage from "./TemplateDocumentsPage";
import TravelPage from "./TravelPage";

const RepPortal = () => (
  <React.Fragment>
    <Switch>
      <Route exact path={SystemRoutes.Dashboard} component={DashboardPage} />
      <Route exact path={SystemRoutes.RepDetails} component={RepDetailsPage} />
      <Route
        exact
        path={SystemRoutes.Conditions}
        component={TermsAndConditionsPage}
      />
      <Route exact path={SystemRoutes.Bookings} component={BookingsListPage} />

      <Route path={BookingRoutes.Booking()} component={BookingDetailsPage} />
      <Route exact path={SystemRoutes.Travel} component={TravelPage} />
      <Route
        exact
        path={SystemRoutes.TemplateDocuments}
        component={TemplateDocumentsPage}
      />
      <Route exact path={AppRoutes.Root} component={DashboardPage} />

      <Route component={NotFound} />
    </Switch>
    <NotificationStack />
  </React.Fragment>
);

export default RepPortal;
